module.exports = __webpack_public_path__ + "static/media/parcel.a010aa9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Services/parcel.svg
// module id = 167
// module chunks = 0